export const productShowcases = {
  'web-management': {
    key: 'web-management',
    shortName: '网页后台',
    name: '网页管理后台',
    eyebrow: '学校与教师网页管理端',
    headline: '打开浏览器，\n集中管理学校与班级业务',
    description: '面向学校管理员和教师的网页工作空间，统一维护学校、班级、教师、学生、设备与业务数据，并集中查看广播任务和运行记录。',
    promise: '无需安装，用浏览器进入统一管理空间',
    accent: '#6f4bd8',
    accentDark: '#3f258e',
    accentSoft: '#f1edff',
    icon: 'global',
    status: '浏览器网页端',
    audiences: ['学校管理员', '班主任', '任课教师'],
    metrics: [
      { value: '1个', label: '统一管理入口' },
      { value: '多角色', label: '权限空间' },
      { value: '实时', label: '业务与设备数据' }
    ],
    features: [
      { title: '学校与班级管理', text: '维护学校资料、班级结构和教师班级关系。', icon: 'classroom' },
      { title: '用户与学生数据', text: '统一管理教师、学生、家长及相关业务档案。', icon: 'team' },
      { title: '广播任务管理', text: '创建广播任务并查询发送记录和接收结果。', icon: 'sound' },
      { title: '设备与在线状态', text: '查看教室设备连接情况，辅助判断信息能否触达。', icon: 'online' },
      { title: '业务统计查询', text: '按权限范围查看学校、班级和业务运行数据。', icon: 'growth' },
      { title: '统一权限保护', text: '不同角色只访问所属学校和已授权班级的数据。', icon: 'shield' }
    ],
    journey: [
      { step: '01', title: '登录统一账号', text: '进入所属学校及角色权限空间。' },
      { step: '02', title: '选择管理模块', text: '进入学校、班级、学生、设备或广播业务。' },
      { step: '03', title: '完成配置与查询', text: '维护数据、发起任务并查看运行状态。' },
      { step: '04', title: '同步其他产品端', text: '业务结果同步到工作台、移动端和教室端。' }
    ],
    scenes: ['管理员集中维护学校、班级和教师数据', '教师在电脑浏览器中查询班级与学生信息', '发送广播后查看任务记录和教室在线状态'],
    primaryAction: { label: '登录网页后台', path: '/login' },
    secondaryAction: { label: '查看使用指南', path: '/guide' }
  },
  'teacher-workbench': {
    key: 'teacher-workbench',
    shortName: '工作台',
    name: '教师工作台',
    eyebrow: '教师桌面主工作端',
    headline: '把教师一天的工作，\n放进一个清晰的工作台',
    description: '面向教师的桌面工作空间，将学校任务、课堂广播、班级事务、学生成长与家校协同集中处理，减少在多个后台和工具之间反复切换。',
    promise: '一台电脑，完成教师高频工作的完整闭环',
    accent: '#2667ff',
    accentDark: '#123a9a',
    accentSoft: '#edf3ff',
    icon: 'laptop',
    status: 'Windows 桌面端',
    audiences: ['班主任', '任课教师', '年级教师'],
    metrics: [
      { value: '5', label: '工作领域' },
      { value: '14+', label: '核心业务入口' },
      { value: '1套', label: '学校与班级数据' }
    ],
    features: [
      { title: '学校任务统一接收', text: '集中查看学校通知、待办和日常任务，重要事项不再散落。', icon: 'notification' },
      { title: '课堂广播即时触达', text: '面向一个或多个班级发送文字、语音和场景化提醒。', icon: 'sound' },
      { title: '班级与学生管理', text: '管理班级、课表、座位、考勤、积分、作业和学生档案。', icon: 'team' },
      { title: '成长与家校协同', text: '沉淀成长记录、成绩和反馈，让后续沟通有据可依。', icon: 'growth' },
      { title: '教师工具集中使用', text: '数据收集、扫码活动、教学文件和常用工具统一入口。', icon: 'tool' },
      { title: '真实权限与数据', text: '沿用学校、班级和教师权限，不建立另一套孤立数据。', icon: 'shield' }
    ],
    journey: [
      { step: '01', title: '登录教师身份', text: '进入所属学校和已授权班级。' },
      { step: '02', title: '选择工作领域', text: '任务、教学、班级、学生或家校协同。' },
      { step: '03', title: '完成集中处理', text: '在一个窗口内完成查看、编辑、发送和反馈。' },
      { step: '04', title: '多端同步结果', text: '数据同步到管理后台、小程序和教室端。' }
    ],
    scenes: ['早晨集中处理学校通知与班级待办', '课堂前向多个班级发送准备提醒', '课后录入成绩、成长记录和作业反馈'],
    primaryAction: { label: '查看安装方式', path: '/download' },
    secondaryAction: { label: '注册教师账号', path: '/register' }
  },
  'classroom-desktop': {
    key: 'classroom-desktop',
    shortName: '教室端',
    name: '教室桌面客户端',
    eyebrow: '教室现场执行端',
    headline: '让每一条通知，\n真正到达教室现场',
    description: '常驻班级大屏或讲台电脑，稳定接收教师和学校发送的信息，以横幅、弹窗、全屏和语音等方式完成课堂现场触达。',
    promise: '从云端发送，到教室屏幕看得见、听得到',
    accent: '#08a969',
    accentDark: '#076340',
    accentSoft: '#e9fbf3',
    icon: 'desktop',
    status: 'Windows 教室端',
    audiences: ['班级大屏', '讲台电脑', '教室固定设备'],
    metrics: [
      { value: '4种', label: '主要展示方式' },
      { value: '实时', label: '广播接收' },
      { value: '常驻', label: '教室运行状态' }
    ],
    features: [
      { title: '实时广播接收', text: '即时接收教师或学校发送的课堂通知与提醒。', icon: 'sound' },
      { title: '多种展示方式', text: '支持顶部横幅、桌面弹窗、全屏提示等现场样式。', icon: 'layout' },
      { title: '文字与多媒体', text: '承接文字、语音、图片与视频等不同内容形态。', icon: 'media' },
      { title: '定时与重复提醒', text: '按课堂节奏执行定时任务，降低教师重复操作。', icon: 'clock' },
      { title: '班级日常工具', text: '提供座位表、智能考勤等适合教室固定设备的能力。', icon: 'classroom' },
      { title: '在线状态可见', text: '向教师端反馈设备在线状态，帮助确认信息能否触达。', icon: 'online' }
    ],
    journey: [
      { step: '01', title: '绑定班级设备', text: '将教室电脑与对应学校、班级安全关联。' },
      { step: '02', title: '保持客户端常驻', text: '随教室电脑启动并保持在线。' },
      { step: '03', title: '接收广播指令', text: '实时接收教师与学校的合法指令。' },
      { step: '04', title: '现场展示反馈', text: '在教室屏幕展示并回传接收状态。' }
    ],
    scenes: ['课前准备与上课铃后的快速提醒', '临时通知在班级大屏即时展示', '学校统一通知多个教室同步接收'],
    primaryAction: { label: '下载教室客户端', path: '/download' },
    secondaryAction: { label: '查看安装教程', path: '/guide' }
  },
  'wechat-mini-program': {
    key: 'wechat-mini-program',
    shortName: '小程序',
    name: '微信小程序',
    eyebrow: '微信便捷移动端',
    headline: '不必打开电脑，\n随手处理班级事务',
    description: '教师和家长从微信直接进入，在移动场景中完成班级管理、广播、扫码、作业反馈和家校互动，高频操作随时可用。',
    promise: '无需安装，用微信连接教师、家长和班级',
    accent: '#07c160',
    accentDark: '#06763c',
    accentSoft: '#eafaf1',
    icon: 'wechat',
    status: '微信内使用',
    audiences: ['教师', '家长', '学校成员'],
    metrics: [
      { value: '0', label: '额外安装' },
      { value: '双角色', label: '教师与家长' },
      { value: '随时', label: '移动处理' }
    ],
    features: [
      { title: '微信快捷进入', text: '无需额外下载安装，从微信搜索或扫码即可使用。', icon: 'wechat' },
      { title: '班级与学生管理', text: '在手机上查看班级、学生和相关日常信息。', icon: 'team' },
      { title: '移动广播', text: '离开电脑也能快速选择班级并发送提醒。', icon: 'sound' },
      { title: '扫码场景', text: '支持活动、数据收集和课堂中的移动扫码流程。', icon: 'scan' },
      { title: '家长绑定与反馈', text: '家长绑定学生后接收作业、通知并提交反馈。', icon: 'family' },
      { title: '教师随身工具', text: '集合便签、成长记录和多项移动教师工具。', icon: 'tool' }
    ],
    journey: [
      { step: '01', title: '微信扫码进入', text: '识别官方小程序码，无需下载安装。' },
      { step: '02', title: '选择用户身份', text: '教师或家长进入对应使用空间。' },
      { step: '03', title: '完成移动操作', text: '广播、扫码、反馈与信息查询随手完成。' },
      { step: '04', title: '同步系统数据', text: '与工作台、后台和教室端保持一致。' }
    ],
    scenes: ['教师在走廊快速向班级发送提醒', '活动现场扫码登记或评分', '家长在微信查看作业并完成反馈'],
    primaryAction: { label: '查看小程序码', path: '/wechat' },
    secondaryAction: { label: '查看使用指南', path: '/guide' }
  },
  'mobile-app': {
    key: 'mobile-app',
    shortName: '手机 APP',
    name: '手机 APP',
    eyebrow: 'iOS 与 Android 移动客户端',
    headline: '把班级工作，\n带到手机和平板上',
    description: '面向教师与家长的统一移动应用，一套业务主工程覆盖 iOS 和 Android，提供班级、学生、广播、教师工具、家长中心和学校任务等移动能力。',
    promise: '一套移动业务，在 iOS 与 Android 保持一致',
    accent: '#e87024',
    accentDark: '#9a3f10',
    accentSoft: '#fff2e7',
    icon: 'mobile',
    status: '发布准备中',
    audiences: ['移动办公教师', 'iOS 用户', 'Android 用户', '学生家长'],
    metrics: [
      { value: '双平台', label: 'iOS 与 Android' },
      { value: '5个', label: '移动主入口' },
      { value: '统一', label: '业务代码与接口' }
    ],
    features: [
      { title: '班级与学生管理', text: '在移动端查看和处理班级、学生及日常业务信息。', icon: 'team' },
      { title: '移动广播', text: '随时选择目标班级并发送文字、语音或文件内容。', icon: 'sound' },
      { title: '教师工具', text: '集中使用扫码、资料、成绩、考勤和成长相关工具。', icon: 'tool' },
      { title: '家长角色空间', text: '家长绑定学生后查看通知、作业、评语并提交反馈。', icon: 'family' },
      { title: '原生设备能力', text: '承接扫码、拍照、录音、文件选择和系统通知。', icon: 'scan' },
      { title: '统一账号与数据', text: '与网页后台、小程序、工作台和教室端共享权限与业务数据。', icon: 'shield' }
    ],
    journey: [
      { step: '01', title: '通过正式渠道安装', text: '按 iOS 或 Android 平台获取正式应用。' },
      { step: '02', title: '登录角色空间', text: '按教师或家长身份进入对应功能。' },
      { step: '03', title: '完成移动任务', text: '处理广播、扫码、班级、学生和反馈。' },
      { step: '04', title: '同步五端结果', text: '业务结果回到统一学校与班级数据。' }
    ],
    scenes: ['教师离开电脑后继续处理班级事务', '活动现场使用手机扫码、拍照和上传资料', '家长接收学校信息并完成作业或评价反馈'],
    primaryAction: { label: '查看发布与安装', path: '/download' },
    secondaryAction: { label: '查看使用指南', path: '/guide' }
  }
};

export const productShowcaseList = Object.values(productShowcases);
